import { application } from "./application";
import NotificationTestController from "./notification_test_controller";

application.register("notification-test", NotificationTestController);
